import { createContext } from 'react';
export const AppContext = createContext(null);
export const SessionContext = createContext(null);
export const AuthContext = createContext(null);
export const LoadersContext = createContext(null);
